import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

const Wrapper = styled.div`
  display: flex;
  gap: 6px;
  position: absolute;
  top: 24px;
  left: 16px;
  right: 16px;
  z-index: 10;
`

const Bar = styled.div`
  flex: 1;
  height: 2px;
  border-radius: 2px;
  background: ${myPalette.dark.main};
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    height: 100%;
    width: var(--progress, 0%);
    background: ${myPalette.white.main};
    top: 0;
    left: 0;
  }
`

type Props = {
  count: number
  current: number
  progressRefs: React.MutableRefObject<HTMLDivElement[]>
}

export const ProgressBar = ({ count, current, progressRefs }: Props) => {
  return (
    <Wrapper>
      {Array(count)
        .fill(0)
        .map((_, index) => (
          <Bar
            key={index}
            ref={(el) => {
              if (el) progressRefs.current[index] = el
            }}
            style={
              index < current
                ? ({ '--progress': '100%' } as React.CSSProperties)
                : index > current
                ? ({ '--progress': '0%' } as React.CSSProperties)
                : undefined
            }
          />
        ))}
    </Wrapper>
  )
}
